import { ValidationError } from "./domain.error.js";

export class InvalidEmailError extends ValidationError {
  constructor(public readonly invalidValue: string) {
    super(
      `Invalid email address: '${invalidValue}'. Expected format: user@domain.com`,
    );
    Object.defineProperty(this, "name", {
      value: "InvalidEmailError",
    });
  }
}
